
import { format } from "date-fns"

export default {
  data() {
    return {
      loading: true,
      blockDate: null,
    }
  },
  created() {
    this.loadCurrentBlock()
  },
  methods: {
    async loadCurrentBlock() {
      this.loading = true

      const { data } = await this.axios.get(`/api/orders/is-sync-temporarily-blocked`)
      if (!data) return this.blockDate = null

      const hours = (new Date(data.date).getTime() - new Date().getTime()) / (1000 * 60 * 60)
      this.blockDate = { date: data.date, hours, minutes: (hours % 1) * 60 }

      this.loading = false
    },
  },
  computed: {
    blockFormattedDate() {
      const date = this.blockDate && this.blockDate.date
      try {
        return date && format(new Date(date), "dd-MM-yyyy HH:mm")
      } catch (err) {
        return date
      }
    },
  },
}
